/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na ovladače pro zobrazování video souborů.
 */
class ViewerControllerVideoFactory {
  /**
   * Vytvoří instanci
   * @param {Class.<ViewerControllerVideo>} ViewerControllerVideo
   * @param {HtmlMediaUtil} mediaUtil
   * @param {Session} session
   * @param {StretchNative} stretchNative
   * @param {ViewerLifeCycleFactory} viewerLifeCycleFactory
   * @param {null|string} poster
   */
  constructor(
    ViewerControllerVideo,
    mediaUtil,
    session,
    stretchNative,
    viewerLifeCycleFactory,
    poster
  ) {
    // TODO Využít připravené závislosti.
    // - Bude nutný builder pro testy.
    this.ViewerControllerVideo = ViewerControllerVideo;
    this.mediaUtil = mediaUtil;
    this.session = session;
    this.stretchNative = stretchNative;
    this.viewerLifeCycleFactory = viewerLifeCycleFactory;
    this.poster = poster;
  }

  /**
   * Vytvoří nový ovladač.
   * @returns {ViewerControllerVideo}
   */
  create() {
    const { session } = this;
    return new this.ViewerControllerVideo({
      genericViewerVideoSeekDisable:
        session?.genericViewerVideoSeekDisable || false,
      poster: this.poster,
      preloadBlackeningFix:
        session?.genericViewerVideoPreloadBlackeningFix || false,
      preloadBlackeningFixDelay:
        // Experimentálně zjištění, že až po 500 ms lze nastavit původní hodnotu opacity.
        session?.genericViewerVideoPreloadBlackeningFixDelay || 500
    });
  }
}

export default ViewerControllerVideoFactory;
